import React from 'react';

interface AddToCalendarButtonProps {
  sessionId: string;
  className?: string;
}

/**
 * AddToCalendarButton redirects to the session-calendar edge function URL
 * which returns an ICS file that opens directly in the user's calendar app.
 *
 * The ICS file is generated server-side and includes:
 * - Session type and guide name
 * - Online/in-person location indicator
 * - Location details (address) for in-person sessions
 * - Link to seeker home page
 */
export const AddToCalendarButton: React.FC<AddToCalendarButtonProps> = ({
  sessionId,
  className,
}) => {
  const handleClick = () => {
    const env = (window as any).__ENV__;
    const baseUrl = env?.SUPABASE_URL;

    if (!baseUrl) {
      console.error('Missing SUPABASE_URL');
      return;
    }

    // Build URL with session_id - no auth required
    const icsUrl = `${baseUrl}/functions/v1/session-calendar?session_id=${encodeURIComponent(sessionId)}`;

    // Redirect to open the ICS file directly
    window.location.href = icsUrl;
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={
        className ||
        'inline-flex items-center gap-2 rounded-lg border border-[#2C2731] bg-[#FFFCEF] px-3 py-2 text-sm font-medium text-[#2C2731] transition-colors hover:bg-[#E8DFBD] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2C2731] focus-visible:ring-offset-2'
      }
      aria-label="Add session to calendar"
    >
      <svg
        className="h-4 w-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
        />
      </svg>
      Add to Calendar
    </button>
  );
};

export default AddToCalendarButton;
